import { useTranslations } from '@vocab/react';
import { Loader, Text } from 'braid-design-system';
import React from 'react';

import { FormDrawer } from 'src/components/FormDrawer/FormDrawer';
import { APPROACHABILITY } from 'src/components/Router';
import { NEXT_ROLE_APPROACHABILITY_FORM } from 'src/reducers/forms';

import { NextRoleDetail } from '../../ReadNextRole/NextRoleDetail/NextRoleDetail';
import { NextRoleSection } from '../../types';
import { EditApproachability } from '../EditApproachability/EditApproachability';
import { useApproachability } from '../data';

import translations from './.vocab';

export const ReadApproachability = () => {
  const { approachable, error } = useApproachability();

  const { t } = useTranslations(translations);

  return (
    <>
      <NextRoleDetail
        title={t('Approachability')}
        section={NextRoleSection.approachability}
      >
        {error ? (
          <Loader data={{ automation: 'approachability-loading' }} />
        ) : (
          <Text>{approachable ? t('Show') : t('Hide')}</Text>
        )}
      </NextRoleDetail>
      <FormDrawer
        title={t('Approachability')}
        component={EditApproachability}
        card={APPROACHABILITY}
        formName={NEXT_ROLE_APPROACHABILITY_FORM}
      />
    </>
  );
};
